<template>
  <v-container class="ma-0 pa-0">
    <div
      v-if="product.modification"
      class="product__modification-warn mt-2"
    >
      {{ modificationWarn[product.modification] }}
    </div>
    <v-card
      flat
      class="pb-3 pt-1 mb-3 mt-1 mx-1 d-flex"
    >
      <v-img
        id="product-image"
        contain
        :src="getMainImage || 'https://konselior.s3.amazonaws.com/media/semImagem.jpg'"
        class="image-style"
        min-width="150px"
      >
        <div
          v-if="hasSAC || isPreSale"
          :class="isPreSale ? 'product__presale-tag' : 'product__sac__tag'"
        >
          {{ isPreSale ? 'Pré-venda' : sacTag }}
        </div>
        <div
          v-if="hasSAC && getStoreSkuPrice('old')"
          class="product__sac__discount"
        >
          {{ productDiscount }}
        </div>
      </v-img>

      <v-layout class="mx-2 d-flex">
        <v-flex
          xs12
          class="alignment mt-2"
        >
          <div class="d-flex">
            <div class="product__reference">
              Ref.: {{ productReference }}
            </div>
            <v-btn
              small
              icon
              class="delete-btn ma-0"
              style="height: fit-content"
              @click="setToggleProductDialog('exclude', true)"
            >
              <v-icon
                color="#AFAFAF"
                style="font-size: 15px; width: 0"
              >
                mdi-close
              </v-icon>
            </v-btn>
          </div>

          <h3 class="product__name">
            {{ product.descricaoCurta }} {{ getSize }}
          </h3>
          <div
            v-if="product && getCustomer.salesAssistant"
            class="product__options"
          >
            {{
              product.voltage
                ?
                  [
                    product.voltage,
                    product.color
                  ].filter((option) => option).join(' / ')
                : product.color
            }}
          </div>

          <div
            v-if="getCustomer.salesAssistant"
            class="service-wrapper"
          >
            <v-btn
              depressed
              color="#F1F1F1"
              class="edit-btn ml-0 mb-1"
              @click="setToggleProductDialog('edit', true)"
            >
              <v-icon
                small
                class="icon-btn"
              >
                mdi-pencil
              </v-icon>
            </v-btn>

            <v-btn
              v-if="getServices.length && (!product.services || !product.services.length) && (!getPerson.type || getPerson.type === 'PF')"
              depressed
              color="#F1F1F1"
              class="service-btn ml-0 mb-1"
              @click="setToggleProductDialog('services', true)"
            >
              <v-icon
                small
                class="icon-btn mr-1"
              >
                mdi-plus
              </v-icon>
              Adicionar serviço
            </v-btn>

            <v-btn
              v-for="(service, index) in product.services"
              v-else
              :key="service.title + Math.floor(Math.random() * 999)"
              depressed
              color="#F1F1F1"
              class="service-btn ml-0 mb-1"
              @click="excludeProductService(product, index)"
            >
              {{ service.title }} {{ service.price | currency }}
              <v-icon
                small
                class="icon-btn ml-3"
              >
                mdi-close
              </v-icon>
            </v-btn>

            <v-btn
              v-if="(!getPerson.type || getPerson.type === 'PF') && hasWarrantyMobile"
              depressed
              color="#F1F1F1"
              class="service-btn mx-0 mb-0"
            >
              <v-icon
                v-if="!product.warrantyMobile"
                small
                class="icon-btn mr-1"
                @click="setToggleProductDialog('warrantyMobile', true)"
              >
                mdi-plus
              </v-icon>
              <span
                v-if="product.grupoProduto === 'TELEFONIA'"
                @click="setToggleProductDialog('warrantyMobile', true)"
              >
                {{
                  product.warrantyMobile
                    ? `Seguro ${product.warrantyMobile.title} ${$options.filters.currency(product.warrantyMobile.price)}`
                    : ' Adicionar seguro mobile'
                }}
              </span>
              <v-icon
                v-if="product.warrantyMobile"
                small
                class="icon-btn ml-3"
                @click="removeProductWarranty(product, 'warrantyMobile')"
              >
                mdi-close
              </v-icon>
            </v-btn>

            <v-btn
              v-if="(!getPerson.type || getPerson.type === 'PF') && hasWarranty"
              depressed
              color="#F1F1F1"
              class="service-btn mx-0 mb-0"
            >
              <v-icon
                v-if="!product.warranty"
                small
                class="icon-btn mr-1"
                @click="setToggleProductDialog('warranty', true)"
              >
                mdi-plus
              </v-icon>
              <span @click="setToggleProductDialog('warranty', true)">
                {{
                  product.warranty
                    ? `Garantia ${product.warranty.title} ${$options.filters.currency(product.warranty.price)}`
                    : ' Adicionar garantia estendida'
                }}
              </span>
              <v-icon
                v-if="product.warranty"
                small
                class="icon-btn ml-3"
                @click="removeProductWarranty(product, 'warranty')"
              >
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card>

    <v-container
      v-if="getCustomer.salesAssistant"
      class="value__wrapper mb-3"
    >
      <div class="value__item">
        Valor un.
      </div>

      <div class="value__item">
        Quantidade
      </div>

      <div
        class="value__item"
      >
        Valor total
      </div>

      <div
        class="value__item__unit-price"
      >
        <span
          v-if="product.oldPrice || product.old_price"
          class="value__number__old"
        >
          {{ product.oldPrice || product.old_price | currency }}
        </span>
        <span
          class="value__number"
          :style="{ color: hasSAC ? '#FF5146' : '#140C22' }"
        >
          {{ product.price | currency }}
        </span>
      </div>

      <div
        class="value__item"
      >
        <v-btn
          depressed
          color="#F1F1F1"
          class="qt-product mr-3 ml-0"
          @click="changeProductQuantity('reduce')"
        >
          -
        </v-btn>
        <div class="value__number">
          {{ product.quantity }}
        </div>
        <v-btn
          depressed
          color="#F1F1F1"
          class="qt-product ml-3 mr-0"
          @click="changeProductQuantity('increase')"
        >
          +
        </v-btn>
      </div>

      <div class="value__item value__number">
        {{ totalProductCost | currency }}
      </div>
    </v-container>
  </v-container>
</template>

<script>
/* eslint-disable camelcase */
import { mapGetters } from 'vuex';
import { EventBus } from '../../event-bus';
import { sacTags } from '../../utils/enum';

export default {
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    productIdx: {
      type: Number,
      default: undefined,
    },
    storeId: {
      type: Number,
      default: 0,
    },
    toggleProductDialog: {
      type: Function,
      default: () => {},
    },
  },

  data: () => ({
    modificationWarn: {
      zeroStock: 'Produto sem unidades em estoque. Altere as especificações ou retire da seleção.',
      newPrice: 'Produto com alteração de valor.',
    },
  }),

  computed: {
    ...mapGetters(['getStore', 'getCustomer', 'getPerson', 'getCatalogue']),

    getSelectedSku() {
      return this.product.skus.find((sku) => sku.id === this.product.sku_id);
    },

    hasSAC() {
      return this.getSelectedSku.product_type_id < 4;
    },

    // Real number to be determined by the brand
    isPreSale() {
      return this.getSelectedSku.product_type_id === 12;
    },

    sacTag() {
      return sacTags[this.getSelectedSku.product_type_id];
    },

    productDiscount() {
      const percentage = Math.round(
        (1 - (this.getStoreSkuPrice('regular') / this.getStoreSkuPrice('old'))) * 100,
      );

      return `-${percentage}%`;
    },

    totalProductCost() {
      const productCost = this.product.price * this.product.quantity;
      const warrantyCost = (this.product.warranty ? this.product.warranty.price * this.product.quantity : 0);
      const warrantyMobileCost = (this.product.warrantyMobile ? this.product.warrantyMobile.price * this.product.quantity : 0);
      const servicesCost = this.product.services && this.product.services.length
        ? this.product.services.reduce((acc, cur) => acc + cur.price, 0)
        : 0;

      return productCost + warrantyCost + servicesCost + warrantyMobileCost;
    },

    getHighestPrice() {
      let maxSkuPrice = {};
      let maxPrice = -Infinity;

      this.product.skus.forEach((sku) => {
        const { price } = sku.sku_prices[0];

        if (price && price > maxPrice) {
          maxPrice = price;
          maxSkuPrice = sku;
        }
      });

      return maxSkuPrice;
    },

    getSize() {
      if (this.product.size) {
        return typeof this.product.size === 'object'
          ? this.product.size.value
          : this.product.size;
      }
      return '';
    },

    getMainImage() {
      const skuImage = this.product.skus.find((sku) => sku.sku_images.some((image) => image.is_main));
      return skuImage ? skuImage.sku_images.find((image) => image.is_main).image : '';
    },

    getServices() {
      return this.product.skus[0].sku_add_ons.filter((skuAddOn) => skuAddOn.type === 'PS' && skuAddOn.store_id === this.storeId);
    },

    hasWarranty() {
      return this.product.skus[0].sku_add_ons.find((skuAddOn) => skuAddOn.type === 'GE' && skuAddOn.store_id === this.storeId);
    },

    hasWarrantyMobile() {
      return this.product.skus[0].sku_add_ons.find((skuAddOn) => skuAddOn.type === 'SM' && skuAddOn.store_id === this.storeId);
    },

    productReference() {
      return this.product.reference ? this.product.reference.replace('Ref.: ', '') : '';
    },
  },

  methods: {
    getStoreSkuPrice(priceType) {
      const { old_price, price } = this.getSelectedSku.sku_prices[0];

      const prices = {
        old: (old_price > price) ? old_price : null,
        regular: price,
      };

      return prices[priceType];
    },

    getCurrentStock(id) {
      const products = this.getCatalogue.filter((product) => product.id === id);
      return products.reduce((total, item) => total + Number(item.quantity), 0);
    },

    changeProductQuantity(operation) {
      const values = {
        reduce: this.product.quantity - 1,
        increase: this.product.quantity + 1,
      };
      const { isCD } = this.product;
      const stockCD = isCD ? this.getSelectedSku.sku_stocks.find((skuStock) => skuStock.store.id_erp === '52') : null;

      if (operation === 'reduce' && values[operation] < 1) {
        this.toggleProductDialog(this.product, 'exclude', true);
      } else if (operation === 'increase' && this.product.imei) {
        EventBus.$emit('activeSnackBar', { text: 'Produto já possui um IMEI cadastrado.', value: true, color: 'red' });
      } else if (operation === 'increase' && !isCD && this.getCurrentStock(this.product.id) >= this.product.currentStock) {
        EventBus.$emit('activeSnackBar', { text: 'Limite de estoque atingido', value: true, color: 'red' });
      } else if (isCD && operation === 'increase' && this.getCurrentStock(this.product.id) >= stockCD.stock) {
        EventBus.$emit('activeSnackBar', { text: 'Limite de estoque atingido', value: true, color: 'red' });
      } else {
        this.$set(this.product, 'quantity', values[operation]);
      }
    },

    excludeProductService(product, serviceIndex) {
      product.services.splice(serviceIndex, 1);
      if (!product.services.length) {
        this.$set(product, 'services', []);
      }
      this.$store.dispatch('refreshCatalogue');
    },

    setToggleProductDialog(type, value = true) {
      if (this.productIdx >= 0) {
        this.$emit('change-product-idx', this.productIdx);
      }
      this.toggleProductDialog(this.product, type, value);
    },

    removeProductWarranty(product, warranty) {
      this.$set(product, warranty === 'warranty' ? 'warranty' : 'warrantyMobile', undefined);
      this.$set(product, 'imei', undefined);
      this.$store.dispatch('refreshCatalogue');
    },
  },
};
</script>
<style scoped lang="scss">

%sac-information {
  height: 18px;
  margin: 8px;
  padding: 4px 6px;
  background: #FF5146;
  border-radius: 2px;
  font-family: 'Nunito Sans';
  font-size: 8px;
  line-height: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.image-style {
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: end;
}

.alignment {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  text-align: start;
}

.delete-btn {
  margin-left: 0.5rem !important;
  margin-right: 0 !important;
  position: absolute;
  right: 0;
}

.v-btn--icon.v-btn--small {
  width: 12px;
}

.qt-product {
  display: flex;
  align-items: center;
  min-width: 5px;
  width: 22px;
  height: 22px;
  padding: 0 10px !important;
  border-radius: 6px;
}

.service-wrapper {
  display: flex;
  flex-flow: row wrap;
}

.edit-btn {
  min-width: 5px;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  padding: 6px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
}

.service-btn {
  font-family: 'Roboto', sans-serif;
  font-size: min(2.5vw, 12px);
  font-weight: 400;
  text-transform: none;
  height: 26px;
  border-radius: 6px;
  padding: 6px 10px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
}

.icon-btn {
  width: fit-content;
  font-size: 14px !important;
}

.product {
  &__reference {
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    font-size: 10px;
    color: #AFAFAF;
  }
  &__name {
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #140C22;
  }
  &__options {
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    color: #8A8691;
  }
  &__sac {
    &__tag {
      @extend %sac-information;
      width: fit-content;
      color: #FFFFFF;
      background: #FF5146
    }
    &__discount {
      @extend %sac-information;
      position: absolute;
      top: 0;
      left: 0;
      color: #FFFFFF;
    }
  }
  &__presale-tag {
    @extend %sac-information;
    background: #FFC56F;
    padding: 4px 12px;
  }
  &__modification-warn {
    font: 700 12px/16px 'Nunito Sans';
    padding: 10px 12px;
    background: #FF5146;
    border-radius: 4px;
    color: #FFF;
    text-align: start;
  }
}

.value {
  &__wrapper {
    display: grid;
    padding: 0;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 0 10%;
  }
  &__item {
    display: flex;
    align-items: center;
    justify-content: start;
    font: 400 12px 'Roboto', sans-serif;
    color: #8A8691;
    &__unit-price {
      @extend .value__item;
      flex-direction: column;
      align-items: start;
      justify-content: center;
    }
  }
  &__number {
    color: #140C22;
    font-size: min(3.5vw, 20px);
    font-weight: 600;
    &__old {
      @extend .value__number;
      color: #FF5146;
      text-decoration: line-through;
    }
  }
}

::v-deep .v-responsive__content {
  max-width: fit-content;
}
</style>
